import {createBrowserRouter} from "react-router-dom";

export type Router = ReturnType<typeof createBrowserRouter>;

export let router: Router | null = null;

export function setRouter(newRouter: Router) {
  router = newRouter;
}
